export default "__VITE_ASSET__CDCliY6t__"